import React from 'react';
import { getPath } from '../utils/getPath';

export default function ErrorMessage({ message }) {
    return (
        <div
            style={{
                color: '#cc0514',
                paddingBottom: '15px',
                display: 'flex',
            }}
        >
            <img style={{ paddingRight: '15px', width: '64px', height: '64px' }} src={getPath('public/img/warning-icon.svg')} alt={''} />
            <div style={{ flex: 1, margin: 'auto' }} dangerouslySetInnerHTML={{ __html: message }} />
        </div>
    );
}
